module.exports = __webpack_public_path__ + "assets/defaultGray-3df23a.svg";